import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PPP_BL: TStep[] = [
  {
    pageId: PageId.DOG_AGE_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.DOG_OWNER_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.TRAINING_COMMANDS_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.URGE_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.DOG_BREED_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.FACING_CHALLENGES_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.FACING_CHALLENGES_2_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.URGE_PROGRAM_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.FIX_BEHAVIOR_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.URGE_4_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.COMMANDS_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.TRAINING_PLACE_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.TRAINING_FREQUENCY_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.URGE_5_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.PREPARE_FLOW_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.COMMITMENT_SCREEN_PPP_BL,
  },
  {
    pageId: PageId.EMAIL_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.CHAT_UPSELL_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.UPSELL_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.DOWNLOAD_WOOFZ_PPP_BL,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PPP_BL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PPP_BL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
